import React, { useEffect, useState } from "react";
import api from "../../../lib/api";
import { useLang } from "../../../context/LangContext";

export default function DubAudit() {
  const { t, lang } = useLang();
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/dub/audit").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  if (!rows) return <p className="text-muted-foreground">{t("A carregar…", "Loading…")}</p>;
  if (!rows.length) return <p className="text-muted-foreground" data-testid="dub-audit-empty">{t("Sem declarações registadas.", "No declarations recorded.")}</p>;
  return (
    <div className="rounded-2xl border border-white/10 bg-card overflow-x-auto" data-testid="dub-audit-table">
      <table className="w-full text-sm">
        <thead className="bg-white/5 text-left text-xs uppercase tracking-wider text-muted-foreground">
          <tr><th className="px-4 py-3">{t("Data e hora", "Date & time")}</th><th className="px-4 py-3">{t("Utilizador", "User")}</th><th className="px-4 py-3">{t("Vídeo", "Video")}</th><th className="px-4 py-3">IP</th></tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id} className="border-t border-white/10 align-top" data-testid={`dub-audit-row-${r.id}`}>
              <td className="px-4 py-3 whitespace-nowrap">{new Date(r.accepted_at).toLocaleString(lang === "pt" ? "pt-PT" : "en-GB")}</td>
              <td className="px-4 py-3">{r.user_email}</td>
              <td className="px-4 py-3"><div className="font-medium break-words">{r.video_title}</div><div className="text-xs text-muted-foreground break-all">{r.source}</div><div className="mt-1 text-xs italic text-muted-foreground">"{r.statement}"</div></td>
              <td className="px-4 py-3 text-xs text-muted-foreground">{r.ip}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
